export enum AuctionBoxDeadline {
  Coming = 'coming',
  Ended = 'ended',
  InProgess = 'inProgress',
}
